import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { DialogService } from '@services/dialog.service';
import { MenuAction } from '@shared/models/menu-actions/menu-action';
import { MenuActionId } from '@shared/models/menu-actions/menu-action-id.enum';
import { FormGridActionsContext } from '../models/form-grid-actions-context';

@Injectable({ providedIn: 'root' })
export class FormGridActionsService {
  private readonly translocoService = inject(TranslocoService);
  private readonly dialogService = inject(DialogService);

  edit<T>(ctx: FormGridActionsContext<T>): MenuAction<T> {
    return {
      id: MenuActionId.FORM_GRID_EDIT,
      icon: '@tui.pencil',
      hint: this.translocoService.translate('Modifier'),
      condition: () => ctx.mode() === 'readonly' && (!ctx.isLoadedEmpty() || ctx.editCreatesNewEntry),
      execute: () => ctx.enterEdit(),
    };
  }

  add<T>(ctx: FormGridActionsContext<T>): MenuAction<T> {
    return {
      id: MenuActionId.FORM_GRID_ADD,
      icon: '@tui.plus',
      appearance: 'primary',
      hint: this.translocoService.translate('Ajouter'),
      condition: () => ctx.mode() === 'readonly',
      execute: () => ctx.enterAdd(),
    };
  }

  clear<T>(ctx: FormGridActionsContext<T>): MenuAction<T> {
    return {
      id: MenuActionId.FORM_GRID_CLEAR,
      icon: '@tui.eraser',
      hint: this.translocoService.translate('Effacer'),
      condition: () => ctx.mode() !== 'readonly',
      execute: (): void => {
        this.dialogService
          .openConfirm(this.translocoService.translate('Êtes-vous sûr de vouloir effacer ce formulaire ?'), {
            content: this.translocoService.translate('Cette action est irréversible'),
            yes: this.translocoService.translate('Effacer'),
          })
          .subscribe((confirmed) => {
            if (confirmed) {
              ctx.clear();
            }
          });
      },
    };
  }

  defaults<T>(ctx: FormGridActionsContext<T>): MenuAction<T>[] {
    return [this.edit(ctx), this.add(ctx)];
  }
}
